<template>
    <Teleport to="body">
        <Transition
            enter-active-class="transition-[opacity,transform] duration-[180ms] ease-out"
            leave-active-class="transition-[opacity,transform] duration-[180ms] ease-in"
            enter-from-class="opacity-0 scale-95"
            leave-to-class="opacity-0 scale-95"
        >
            <div
                v-if="showAgent"
                ref="widgetRef"
                class="font-sans-rubik fixed touch-none z-100 flex flex-col overflow-hidden select-none max-mob:rounded-0 rounded-2.5 bg-white dark:bg-blue-820 border border-gray-100 dark:border-gray-755 shadow-agent-light dark:shadow-agent-dark"
                :style="draggableStyle"
            >
                <div class="flex flex-col h-full">
                    <div ref="headerRef">
                        <slot name="header"></slot>
                    </div>

                    <slot></slot>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
import {
    computed, watch, useTemplateRef, inject,
} from 'vue'
import { useDraggable } from '@vueuse/core'

import { showHideLiveChat } from '@/helpers/app-helper'

import { viewPorts } from '@/constants/viewPorts'

const showAgent = defineModel('modelValue', { type: Boolean, default: false })

const currentWidth = inject('currentWidth')
const currentHeight = inject('currentHeight')
const currentViewSize = inject('currentViewSize')

const widgetRef = useTemplateRef('widgetRef')
const headerRef = useTemplateRef('headerRef')

const isMobView = computed(() => viewPorts.mob >= currentViewSize.value)

const WIDGET_W = computed(() => (currentWidth.value > 432 && !isMobView.value ? 432 : currentWidth.value))
const WIDGET_H = computed(() => (currentHeight.value > 700 && !isMobView.value ? 700 : currentHeight.value))

const { x, y } = useDraggable(widgetRef, {
    handle: headerRef,
    initialValue: {
        x: currentWidth.value - WIDGET_W.value - 16,
        y: currentHeight.value - WIDGET_H.value - 16,
    },
})

const draggableStyle = computed(() => ({
    left: isMobView.value ? 0 : `${Math.min(Math.max(0, x.value), currentWidth.value - WIDGET_W.value)}px`,
    top: isMobView.value ? 0 : `${Math.min(Math.max(0, y.value), currentHeight.value - WIDGET_H.value)}px`,
    height: `${WIDGET_H.value}px`,
    width: `${WIDGET_W.value}px`,
}))

watch(isMobView, (isMobView) => {
    if (showAgent.value) {
        showHideLiveChat(isMobView)
    }
}, { immediate: true })

watch(showAgent, (value) => {
    if (value) {
        showHideLiveChat(isMobView.value)
    } else {
        showHideLiveChat(false)
    }
})
</script>
